import { omit } from 'lodash';

import { DEFAULT_TICKET_QUANTITY, NormalizedTickets } from '../types';

/**
 * Toggle a ticket in a normalized tickets object.
 */
const toggleTicketTier = (
  ticketsObj: NormalizedTickets,
  toggledTicketId: string
): NormalizedTickets => {
  if (ticketsObj[toggledTicketId]) {
    return omit(ticketsObj, toggledTicketId);
  }

  return {
    ...ticketsObj,
    [toggledTicketId]: { quantity: DEFAULT_TICKET_QUANTITY }
  };
};

export default toggleTicketTier;
